import Loandetails from "../../../jsx/components/Dashboard/LoanDetails/loandetails";

const LoanDetailsWrapper = () => {
  return <Loandetails />;
};

export default constore(LoanDetailsWrapper);
